export const SALUTATIONS = [
  "Mr",
  "Mrs",
  "Ms",
  "Miss",
  "Dr",
  "Prof",
  "Rev",
  "Fr",
  "Hon",
  "Sir",
  "Lord",
  "Lady",
  "Col",
  "Gen",
  "Judge",
  "Ambassador",
  "Chief",
] as const;

export const CUSTOM_SALUTATION_VALUE = "__custom_salutation__";

// Contacts without a chosen salutation are stored on the backend with the
// literal placeholder "N/A" rather than a blank value, so display code needs
// to treat it the same as "no salutation" rather than showing it verbatim.
export const isRealSalutation = (
  value?: string | null,
): value is string => {
  if (!value) return false;
  const trimmed = value.trim();
  return trimmed.length > 0 && trimmed.toLowerCase() !== "n/a";
};
